<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" style="margin-right: 3px;" @click="auditmodal = true">批量配货</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
      <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="computeCol" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-selection-change="onselectionchange"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <install-order-detail-modal v-model="installOrderDetailModal" :initValue="installOrderDetailId"
                                      @on-success="onModifySuccess"></install-order-detail-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId" @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <install-order-base-detail-modal v-model="installOrderBaseDetailModal" :initValue="installOrderBaseDetailId" @on-success="onModifySuccess"></install-order-base-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>

    <Modal
      v-model="auditmodal"
      width="600"
      title="订单配货"
      ok-text="提交"
      @on-visible-change="visibleChange"
      @on-ok="onOk"
      cancel-text="取消">

      <Form v-if="installOrderList.length > 0" :model="installOrderList" :label-width="80">
        <div v-for="item in installOrderList">

          <FormItem prop="registrationNum" label="车牌号">
            <label style="display: inline-block; width: 100px;">{{item.tempVehicleInfo != null ? item.tempVehicleInfo.registrationNum : item.vehicleInfo.registrationNum}}</label>
          </FormItem>

        </div>
        <!--        <FormItem prop="addProcessRemark" label="优惠卷">-->
        <!--          <img @click="onPhotoClick"-->
        <!--               :src="'https://pic.jianchengjt.com/' + item.picKey + '?imageMogr2/thumbnail/600x400'"></img>-->
        <!--        </FormItem>-->
        <FormItem prop="state" label="审核结果">
          <Select style="width: 100px;" v-model="installOrderListstepstate">
            <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="result" label="不通过原因" v-if="installOrderListstepstate == 3">
          <Input style="display: inline-block; width: 400px;" type="textarea" v-model="installOrderListstepresult"
                 placeholder="不通过原因">
          </Input>
        </FormItem>
      </Form>

      <Form v-else :model="installauditResult" :label-width="100">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{installauditResult.tempVehicleInfo != null ? installauditResult.tempVehicleInfo.registrationNum : installauditResult.vehicleInfo.registrationNum}}</label>
        </FormItem>
        <FormItem prop="state" label="配货结果">
          <Select style="width: 100px;" v-model="installauditResult.step.state">
            <Option v-for="item in stepstateOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="result" label="不通过原因" v-if="installauditResult.step.state == 3">
          <Input style="display: inline-block; width: 400px;" type="textarea" v-model="installauditResult.step.result"
                 placeholder="不通过原因">
          </Input>
        </FormItem>

        <FormItem prop="result" label="配件" v-if="installauditResult.step.state == 2">

          <FormItem prop="positioningdevicemodel" label="定位设备类型：">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.positioningDeviceModel.name}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="LCD属性：">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.lcdproperties == true?'开':'关'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="声光报警：" v-if="installauditResult.newPositioningDeviceFittingsModel.StarLightAlarmType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.StarLightAlarmType?installauditResult.newPositioningDeviceFittingsModel.StarLightAlarmType.name:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="对讲机：" v-if="installauditResult.newPositioningDeviceFittingsModel.interphoneType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.interphoneType?installauditResult.newPositioningDeviceFittingsModel.interphoneType.name:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="喇叭：" v-if="installauditResult.newPositioningDeviceFittingsModel.trumpetType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.trumpetType?installauditResult.newPositioningDeviceFittingsModel.trumpetType.name:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="显示屏：" v-if="installauditResult.newPositioningDeviceFittingsModel.viewingScreenType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.viewingScreenType?installauditResult.newPositioningDeviceFittingsModel.viewingScreenType.name:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="硬盘：" v-if="installauditResult.newPositioningDeviceFittingsModel.hardDiskType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.hardDiskType?installauditResult.newPositioningDeviceFittingsModel.hardDiskType.name:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="延长线：" v-if="installauditResult.newPositioningDeviceFittingsModel.extensionCordOneType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.extensionCordOneType?installauditResult.newPositioningDeviceFittingsModel.extensionCordOneType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.extensionCordOneType?installauditResult.newPositioningDeviceFittingsModel.extensionCordOneNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="延长线：" v-if="installauditResult.newPositioningDeviceFittingsModel.extensionCordFiveType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.extensionCordFiveType?installauditResult.newPositioningDeviceFittingsModel.extensionCordFiveType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.extensionCordFiveType?installauditResult.newPositioningDeviceFittingsModel.extensionCordFiveNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="延长线：" v-if="installauditResult.newPositioningDeviceFittingsModel.extensionCordFifteenType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.extensionCordFifteenType?installauditResult.newPositioningDeviceFittingsModel.extensionCordFifteenType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.extensionCordFifteenType?installauditResult.newPositioningDeviceFittingsModel.extensionCordFifteenNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="摄像头：" v-if="installauditResult.newPositioningDeviceFittingsModel.cameraOneType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.cameraOneType?installauditResult.newPositioningDeviceFittingsModel.cameraOneType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.cameraOneType?installauditResult.newPositioningDeviceFittingsModel.cameraOneNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="摄像头：" v-if="installauditResult.newPositioningDeviceFittingsModel.cameraTwoType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.cameraTwoType?installauditResult.newPositioningDeviceFittingsModel.cameraTwoType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.cameraTwoType?installauditResult.newPositioningDeviceFittingsModel.cameraTwoNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="摄像头：" v-if="installauditResult.newPositioningDeviceFittingsModel.cameraThreeType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.cameraThreeType?installauditResult.newPositioningDeviceFittingsModel.cameraThreeType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.cameraThreeType?installauditResult.newPositioningDeviceFittingsModel.cameraThreeNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="摄像头：" v-if="installauditResult.newPositioningDeviceFittingsModel.cameraFourType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.cameraFourType?installauditResult.newPositioningDeviceFittingsModel.cameraFourType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.cameraFourType?installauditResult.newPositioningDeviceFittingsModel.cameraFourNum:'无'}}</label>
          </FormItem>
          <FormItem prop="positioningdevicemodel" label="摄像头：" v-if="installauditResult.newPositioningDeviceFittingsModel.cameraFiveType">
            <label>{{installauditResult.newPositioningDeviceFittingsModel.cameraFiveType?installauditResult.newPositioningDeviceFittingsModel.cameraFiveType.name:'无'}}*{{installauditResult.newPositioningDeviceFittingsModel.cameraFiveType?installauditResult.newPositioningDeviceFittingsModel.cameraFiveNum:'无'}}</label>
          </FormItem>

        </FormItem>
      </Form>

    </Modal>
  </div>
</template>

<script>
import InstallOrderDetailModal from '@/view/om/components/install-order-detail-modal'
import InstallOrderBaseDetailModal from '@/view/om/components/install-order-base-detail-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'distributioninstallorders',
  components: {
    // AddInstallOrderModal,
    InstallOrderDetailModal,
    VehicleInfoDetailModal,
    InstallOrderBaseDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      stateFilter: null,
      installedFilter: null,
      qghyptOptionFilter: null,
      uploadStateFilter: null,
      receptFilter: null,
      installerFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      gdcdgovVehicleStateFilter: null,
      salesChannelFilter: null,

      installers: [],
      marketsales: [],

      // 订单基本信息
      installOrderBaseDetailModal: false,
      installOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,
      registrationNum: null,

      // 安装订单详细信息
      installOrderDetailModal: false,
      installOrderDetailId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      columnsDisplay: [],
      columnHeaders: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let identificationCode = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              identificationCode = params.row.vehicleInfo.identificationCode === null ? '无' : params.row.vehicleInfo.identificationCode
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            } else {
              registrationNum = params.row.tempVehicleInfo.registrationNum === null ? '无' : params.row.tempVehicleInfo.registrationNum
              identificationCode = params.row.tempVehicleInfo.identificationCode === null ? '无' : params.row.tempVehicleInfo.identificationCode
              vin = params.row.tempVehicleInfo.vin === null ? '无' : params.row.tempVehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum + '(识别码:' + identificationCode + ')'),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '公司资料',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleInfoGroup) {
              return h('div', '公司名称:' + params.row.vehicleInfoGroup.name)
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '加急订单',
          resizable: true,
          key: 'urgent',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          render: (h, params) => {
            const urgent = params.row.urgent
            if (urgent != null) {
              if (urgent) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '加急')
                ])
              } else {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '普通')
                ])
              }
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '指派', value: 1 },
            { label: '完成', value: 2 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 },
            { label: '审核', value: 3 },
            { label: '配货', value: 4 },
            { label: '安装', value: 5 },
            { label: '回访', value: 6 },
            { label: '收款', value: 7 }
          ],
          filterMultiple: true,
          filteredValue: [4],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (params.row.installer != null) {
                step = 2
              }
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待指派')
              } else if (step === 2) {
                return h('div', '已指派')
              } else if (step === 3) {
                return h('div', '指派失败')
              }
            } else if (state === 2) {
              return h('div', '完成')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            } else if (state === 3) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待配货')
              } else if (step === 2) {
                return h('div', '已配货')
              } else if (step === 3) {
                return h('div', '配货失败')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待安装')
              } else if (step === 2) {
                return h('div', '已安装')
              } else if (step === 3) {
                return h('div', '安装失败')
              }
            } else if (state === 6) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 7) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '预约信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 240,
          render: (h, params) => {
            let bookingDatetime
            let bookingPlace
            let actualDatetime
            let actualPlace
            if (params.row.actualDatetime) {
              if (params.row.actualDatetime) {
                actualDatetime = new Date(params.row.actualDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                actualDatetime = '无'
              }
              if (params.row.actualPlace) {
                actualPlace = params.row.actualPlace
              } else {
                actualPlace = '无'
              }
              return h('div', [
                h('div', '重新预约时间:' + actualDatetime),
                h('div', '重新预约地点:' + actualPlace)
              ])
            } else {
              if (params.row.bookingDatetime) {
                bookingDatetime = new Date(params.row.bookingDatetime).Format('yyyy年MM月dd日 hh:mm')
              } else {
                bookingDatetime = '无'
              }
              if (params.row.bookingPlace) {
                bookingPlace = params.row.bookingPlace
              } else {
                bookingPlace = '无'
              }
              return h('div', [
                h('div', '预约时间:' + bookingDatetime),
                h('div', '预约地点:' + bookingPlace)
              ])
            }
          }
        },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '业务类型',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 100,
          render: function (h, params) {
            let businessType = params.row.businessType
            if (businessType === 1) {
              return h('div', '新装')
            } else if (businessType === 2) {
              return h('div', '接入')
            } else if (businessType === 3) {
              return h('div', '在网升级')
            }
          }
        },
        {
          title: '设备详细',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDevice = null
            let positioningDeviceinfo = null
            if (params.row.positioningDevice != null) {
              positioningDevice = params.row.positioningDevice
            }
            let PositioningDeviceFittingsModel = null
            let newPositioningDeviceinfo = null
            if (params.row.newPositioningDeviceFittingsModel != null) {
              PositioningDeviceFittingsModel = params.row.newPositioningDeviceFittingsModel
            }
            if (positioningDevice) {
              positioningDeviceinfo = positioningDevice.positioningDeviceModel.name + '(' + new Date(positioningDevice.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (PositioningDeviceFittingsModel) {
              newPositioningDeviceinfo = PositioningDeviceFittingsModel.positioningDeviceModel.name + '(' + new Date(params.row.serviceDatetime).Format('yyyy年MM月dd日') + ')'
            }
            if (positioningDevice != null && PositioningDeviceFittingsModel != null) {
              return h('div', [
                h('div', '原设备:' + positioningDeviceinfo),
                h('div', '升级设备:' + newPositioningDeviceinfo)
              ])
            } else {
              let positioningDeviceInfos = null
              let positioningDeviceInfo = null
              if (params.row.positioningDeviceInfos) {
                positioningDeviceInfos = params.row.positioningDeviceInfos
                positioningDeviceInfo = positioningDeviceInfos[0].positioningDeviceModel.name + '(' + new Date(positioningDeviceInfos[0].serviceDatetime).Format('yyyy年MM月dd日') + ')'
              }
              if (positioningDeviceInfo) {
                return h('div', [
                  h('div', '设备:' + positioningDeviceInfo)
                ])
              } else {
                return h('div', [
                  h('div', '无')
                ])
              }
            }
          }
        },
        {
          title: '摄像头通道',
          resizable: true,
          key: 'businessType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 220,
          render: function (h, params) {
            let positioningDeviceInfos = null
            if (params.row.positioningDeviceInfos) {
              positioningDeviceInfos = params.row.positioningDeviceInfos
            }
            var str = ''
            if (positioningDeviceInfos != null && positioningDeviceInfos.length > 0) {
              if (positioningDeviceInfos[0].aisleOne != null && positioningDeviceInfos[0].aisleOne) {
                str += '1-'
              }
              if (positioningDeviceInfos[0].aisleTwo != null && positioningDeviceInfos[0].aisleTwo) {
                str += '2-'
              }
              if (positioningDeviceInfos[0].aisleThree != null && positioningDeviceInfos[0].aisleThree) {
                str += '3-'
              }
              if (positioningDeviceInfos[0].aisleFour != null && positioningDeviceInfos[0].aisleFour) {
                str += '4-'
              }
              if (positioningDeviceInfos[0].aisleFive != null && positioningDeviceInfos[0].aisleFive) {
                str += '5-'
              }
              if (positioningDeviceInfos[0].aisleSix != null && positioningDeviceInfos[0].aisleSix) {
                str += '6-'
              }
              if (positioningDeviceInfos[0].aisleSeven != null && positioningDeviceInfos[0].aisleSeven) {
                str += '7-'
              }
              if (positioningDeviceInfos[0].aisleEight != null && positioningDeviceInfos[0].aisleEight) {
                str += '8-'
              }
              if (positioningDeviceInfos[0].aisleNine != null && positioningDeviceInfos[0].aisleNine) {
                str += '9-'
              }
              if (positioningDeviceInfos[0].aisleTen != null && positioningDeviceInfos[0].aisleTen) {
                str += '10-'
              }
            }
            str = str.substring(0, str.length - 1)
            // console.log(str)
            if (positioningDeviceInfos != null && positioningDeviceInfos[0].positioningDeviceModel.adas) {
              return h('div', [
                h('div', '通道:' + str)
              ])
            } else {
              return h('div', [
                h('div', '无')
              ])
            }
          }
        },
        {
          title: '配件列表',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'newPositioningDeviceFittingsModel',
          width: 260,
          render: function (h, params) {
            let str1 = ''
            let str2 = ''
            let PositioningDeviceFittings = params.row.newPositioningDeviceFittingsModel
            if (PositioningDeviceFittings) {
              if (PositioningDeviceFittings.starLightAlarm) {
                if (PositioningDeviceFittings.starLightAlarmType) {
                  str1 += PositioningDeviceFittings.starLightAlarmType.name + ','
                }
              }
              if (PositioningDeviceFittings.viewingScreen) {
                if (PositioningDeviceFittings.viewingScreenType) {
                  str1 += PositioningDeviceFittings.viewingScreenType.name + ','
                }
              }
              if (PositioningDeviceFittings.interphone) {
                if (PositioningDeviceFittings.interphoneType) {
                  str1 += PositioningDeviceFittings.interphoneType.name + ','
                }
              }
              if (PositioningDeviceFittings.trumpet) {
                if (PositioningDeviceFittings.trumpetType) {
                  str1 += PositioningDeviceFittings.trumpetType.name + ','
                }
              }
              if (PositioningDeviceFittings.hardDisk) {
                if (PositioningDeviceFittings.hardDiskType) {
                  str1 += PositioningDeviceFittings.hardDiskType.name + ','
                }
              }
              if (PositioningDeviceFittings.extensionCord) {
                if (PositioningDeviceFittings.extensionCordOneType) {
                  str1 += PositioningDeviceFittings.extensionCordOneType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordOneNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFiveType) {
                  str1 += PositioningDeviceFittings.extensionCordFiveType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFiveNum + ','
                }
                if (PositioningDeviceFittings.extensionCordFifteenType) {
                  str1 += PositioningDeviceFittings.extensionCordFifteenType.name
                  str1 += '*' + PositioningDeviceFittings.extensionCordFifteenNum + ','
                }
              }

              if (PositioningDeviceFittings.camera) {
                if (PositioningDeviceFittings.cameraOneType) {
                  str2 += PositioningDeviceFittings.cameraOneType.name
                  str2 += '*' + PositioningDeviceFittings.cameraOneNum + ','
                }
                if (PositioningDeviceFittings.cameraTwoType) {
                  str2 += PositioningDeviceFittings.cameraTwoType.name
                  str2 += '*' + PositioningDeviceFittings.cameraTwoNum + ','
                }
                if (PositioningDeviceFittings.cameraThreeType) {
                  str2 += PositioningDeviceFittings.cameraThreeType.name
                  str2 += '*' + PositioningDeviceFittings.cameraThreeNum + ','
                }
                if (PositioningDeviceFittings.cameraFourType) {
                  str2 += PositioningDeviceFittings.cameraFourType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFourNum + ','
                }
                if (PositioningDeviceFittings.cameraFiveType) {
                  str2 += PositioningDeviceFittings.cameraFiveType.name
                  str2 += '*' + PositioningDeviceFittings.cameraFiveNum + ','
                }
              }
            }
            return h('div', [
              h('div', str1),
              h('div', str2)
            ])
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 260,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            if (params.row.businessType != 3) {
              if (params.row.vehicleInfoId) {
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderBaseDetailId = params.row.id
                        this.installOrderBaseDetailModal = true
                      }
                    }
                  }, '订单信息')
                )
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.vehicleInfoDetailId = params.row.vehicleInfoId
                        this.vehicleInfoDetailModal = true
                      }
                    }
                  }, '车辆信息')
                )
              } else {
                display.push(
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: false
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.installOrderDetailId = params.row.id
                        this.installOrderDetailModal = true
                      }
                    }
                  }, '详细信息')
                )
              }
            } else {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.installOrderBaseDetailId = params.row.id
                      this.installOrderBaseDetailModal = true
                    }
                  }
                }, '订单信息')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.vehicleInfoDetailId = params.row.vehicleInfoId
                      this.vehicleInfoDetailModal = true
                    }
                  }
                }, '车辆信息')
              )
            }
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleSelectAll(false)
                    this.installauditResult = params.row
                    this.auditmodal = true
                  }
                }
              }, '订单配货')
            )

            return display
          }
        }
      ], // cloumn

      auditmodal: false,
      stepstateOptions: [
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
      ],
      // 配件列表
      split1: 0.5,
      // 设备类型
      positioningDeviceType: [],
      // 声光报警类型
      starLightAlarmType: [],
      // 对讲机类型
      interphoneType: [],
      // 喇叭类型
      trumpetType: [],
      // 显示屏类型
      viewingScreenType: [],
      // 硬盘类型
      hardDiskType: [],
      // 延长线类型
      extensionCordType: [],
      // 摄像头类型
      cameraType: [],

      FittingsType: [
        { label: '摄像头', value: 1 },
        { label: '显示屏', value: 2 },
        { label: '延长线', value: 3 },
        { label: '硬盘', value: 4 },
        { label: '声光报警', value: 5 },
        { label: '对讲机', value: 6 },
        { label: '喇叭', value: 7 },
        { label: '天线', value: 8 },
        { label: '电源线', value: 9 }
      ],

      //  配货订单
      installauditResult: {
        totalAmount: 0,
        serviceDatetime: null,
        businessUserId: null,
        businessType: 1,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        remark: null,
        billType: 1,
        vehicleInfoGroupId: null,
        vehicleInfoGroupId: null,
        positioningDeviceId: null,
        vehicleInfoId: null,
        isfree: 1,
        reInstall: false,
        tempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          salesChannelId: null,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        bookingDatetime: new Date(new Date().setDate(new Date().getDate() + 1)),
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null,
        newPositioningDeviceFittingsModel: {

        }

      },

      installOrderList: [],
      installOrderIds: [],
      installOrderListstepstate: null,
      installOrderListstepresult: null
    }// return
  }, // data
  methods: {
    ...mapActions([
      'InstallOrderServ_GetMyBusinessPage'
    ]),
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      // console.log(selection)
      this.installOrderList = selection
      if (selection.length > 0) {
        selection.forEach(item => {
          this.installOrderIds.push(item.id)
        })
      } else {
        this.installOrderIds = []
      }
      // console.log(this.installOrderList.length)
    },
    handleSelectAll (status) {
      this.$refs.table.selectAll(status)
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装员') {
          this.columns[i].filters = this.installers
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let qo7 = null
      let qo8 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 4)]
      }
      if (this.installedFilter) {
        queryParams.push(this.installedFilter)
      }
      if (this.qghyptOptionFilter) {
        qo2 = this.qghyptOptionFilter
      }
      if (this.uploadStateFilter) {
        qo3 = this.uploadStateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.installerFilter) {
        qo4 = this.installerFilter
      }
      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo6 = this.billTypeFilter
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo7 = this.gdcdgovVehicleStateFilter
      }
      if (this.salesChannelFilter) {
        qo8 = this.salesChannelFilter
      }

      store.dispatch('InstallOrderServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          qo8: qo8,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    // 提交配货
    onOk () {
      if (this.installOrderList != null && this.installOrderList.length > 0) {
        store.dispatch('InstallOrderServ_BatchDistribution', {
          params:
            {
              installOrderList: this.installOrderIds,
              state: this.installOrderListstepstate,
              result: this.installOrderListstepresult
            },
          urlparams: null
        }).then(() => {
          this.onModifySuccess()
        }).catch((err) => {
          console.log(err)
        })
      } else {
        store.dispatch('InstallOrderServ_Distribution', {
          params: this.installauditResult,
          urlparams: null
        }).then(() => {
          this.onModifySuccess()
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.cameraType = []
        this.extensionCordType = []
        this.hardDiskType = []
        this.starlightalarmType = []
        this.interphoneType = []
        this.trumpetType = []
        this.modify = false
        store.dispatch('PositioningDeviceTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          if (store.getters.get_PositioningDeviceType_GetAllResult) {
            this.positioningDeviceType = []
            store.getters.get_PositioningDeviceType_GetAllResult.forEach(item => {
              if (item.adas) {
                this.positioningDeviceType.push(item)
              }
            })
            // this.positioningDeviceType = store.getters.get_PositioningDeviceType_GetAllResult
          }
        }).catch(err => {
          console.log(err)
        })

        store.dispatch('PositioningDeviceFittingsTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          if (store.getters.get_PositioningDeviceFittingsType_GetAllResult) {
            store.getters.get_PositioningDeviceFittingsType_GetAllResult.forEach(item => {
              // 摄像头
              if (item.positioningDeviceFittingFirstOrderTypeId == 1) {
                this.cameraType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 2) {
                this.viewingScreenType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 3) {
                this.extensionCordType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 4) {
                this.hardDiskType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 5) {
                this.starlightalarmType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 6) {
                this.interphoneType.push(item)
              }
              if (item.positioningDeviceFittingFirstOrderTypeId == 7) {
                this.trumpetType.push(item)
              }
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    computeCol () {
      let columns = this.columns
      columns = columns.filter(col => {
        for (var i = 0; i < this.columnsDisplay.length; i++) {
          if (this.columnsDisplay[i] === col.title) {
            return true
          }
        }
        return false
      })
      return columns
    },
    totalElements () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_InstallOrder_GetMyUserGroupPageResult) {
        return store.getters.get_InstallOrder_GetMyUserGroupPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.columns.forEach(item => {
        this.columnHeaders.push(item.title)
        this.columnsDisplay.push(item.title)
      })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => { return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id } })
        // this.columns[4].filters = this.installers
        store.dispatch('SalesChannelServ_GetAll', {
          params: null,
          urlparams: null
        }).then(() => {
          let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
          this.allSalesChannels = allSalesChannels.map(item => {
            return { label: item.name, value: item.id }
          })
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
